const Price = {
  type: 'Price',
  title: 'Price Band',
};

export default Price;
